export default {"src":"/_next/static/media/full-yard.cfb37412.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};